import { render, staticRenderFns } from "./compareUpload.vue?vue&type=template&id=4e1a9266&scoped=true"
import script from "./compareUpload.vue?vue&type=script&lang=js"
export * from "./compareUpload.vue?vue&type=script&lang=js"
import style0 from "./compareUpload.vue?vue&type=style&index=0&id=4e1a9266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a9266",
  null
  
)

export default component.exports